<script>
	export let options = []
	export let value = null
	export let prefix = null
	export let postfix = null
</script>

<div class="buttons">
	{#each options as o}
		<div
			class="button"
			class:active={o.value === value}
			on:click={() => {
				value = o.value
			}}>
			<span>{o.label}</span>
		</div>
	{/each}
</div>

<style lang="scss">
	.buttons {
		text-align: left;
		position: relative;
		margin: 20px 0;
		user-select: none;
		/*
    &::before {
      content: ' ';
      width: 100%;
      left: 0;
      right: 0;
      height: 1px;
      top: 50%;
      background: #2a2a2a;
      position: absolute;
    }
    */
	}

	.button {
		padding: 6px 10px;
		margin: 0 5px 0 0;
		display: inline-block;
		position: relative;
		white-space: nowrap;
		font-weight: 500;
		font-size: 16px;
		line-height: 16px;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		background: #fff;
		border: 1px solid #2a2a2a;

		@media (max-width: 480px) {
			font-size: 15px;
			line-height: 15px;
		}
	}

	.button span {
		z-index: 1;
		position: relative;
	}

	.button.active {
		pointer-events: none;
		background: #2a2a2a;
		color: #fff;
	}

	.button:not(.active):hover {
		background: #ddd;
	}
</style>
